import { instance } from '@/api/instance';

export const TICKETS_PER_PAGE = 30;

export async function getTicketByUuid(uuid) {
  return instance.get(`tickets/${uuid}`);
}

export async function updateTicket(uuid, data) {
  return instance.patch(`tickets/${uuid}`, data);
}

export async function getTicketTypes() {
  try {
    return instance.get(`ticket-types`);
  } catch (e) {
    console.error(e);
  }
}

/**
 * Извлекает массив типов обращений из ответа GET ticket-types (пагинация message.data или плоский message).
 *
 * @param {Object|null|undefined} ticketTypesResponse — ответ axios getTicketTypes()
 * @returns {Array}
 */
export function extractTicketTypesList(ticketTypesResponse) {
  if (!ticketTypesResponse || !ticketTypesResponse.data) {
    return [];
  }
  const message = ticketTypesResponse.data.message;
  if (!message) {
    return [];
  }
  if (Array.isArray(message.data)) {
    return message.data;
  }
  if (Array.isArray(message)) {
    return message;
  }
  return [];
}

export async function removeTicketTypes(uuid) {
  try {
    return instance.delete(`ticket-types/${uuid}`);
  } catch (e) {
    console.error(e);
  }
}

export async function getHistoryChanges(ticket_id) {
  try {
    return instance.get(`history-changes?ticket_id=${ticket_id}&per_page=20`);
  } catch (e) {
    console.error(e);
  }
}

export async function downloadTicket({ uuid, format }) {
  instance.defaults.responseType = 'blob';
  const response = instance.get(`tickets/summary?uuid=${uuid}&format=${format}`);
  instance.defaults.responseType = 'json';
  return response;
}
